module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA2UlEQVR4AWOgCzgnqAZBn1dJQhjPq2SBCFkQghAa4mc7fz4n+eeiGFYElAIqQNHAUBWn1RF09YgipmqgIFAKqABdAxDx1EXP3WD4bYfE0yK5pwVyPw6KA7lAQZAspoanJ2WAJHtZzGkXtefVskA9h7w1IEqxa1gfpgskFbJCbzkr/Tol/vOY+A0bJdaKWJwaIIipMvaohcabfum3U6S3OejgswGIOGtBfvi+TwLogWflckBLgFygIHYN6u3Blw4rYYYSUBAoBdeAiIcPZ3HGA1AKEg+kx/SgBAA5tsbpPqMhnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GD.png
// module id = 1144
// module chunks = 0